import { Instagram, ArrowUpRight } from 'lucide-react';

const galleryItems = [
  {
    label: 'Ver pratos',
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/f6ae8e25097a8516c9c97bd8dcca56c5.png',
  },
  {
    label: 'Ver ambiente',
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/b746d8a7179098e27d6e06fe26f79b6e.png',
  },
  {
    label: 'Ver drinks',
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/046a336de0ef078bc12364327bf2478b.png',
  },
  {
    label: 'Ver música ao vivo',
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/c02641e2ca1d1d0a842611d79c2e8268.png',
  },
  {
    label: 'Ver novidades',
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/3919c56f4a61bb4c6ca2847b3e241b7e.png',
  },
];

export default function GallerySection() {
  return (
    <section id="galeria" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              GALERIA
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              Acompanhe no Instagram
            </h2>
            <p className="text-brown-600 text-base md:text-lg max-w-2xl mx-auto">
              Siga o Buteco do Baiano no Instagram e fique por dentro de tudo que acontece por lá.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {galleryItems.map((item, i) => (
              <a
                key={item.label}
                href="https://instagram.com/butecodobaianooficial"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative rounded-xl overflow-hidden aspect-square shadow-sm hover:shadow-lg transition-all duration-300 reveal"
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-white text-xs font-semibold">{item.label}</span>
                  <ArrowUpRight size={14} className="text-white/70 group-hover:text-white transition-colors" />
                </div>
              </a>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-10 reveal">
            <a
              href="https://instagram.com/butecodobaianooficial"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-yellow-500 text-white font-semibold rounded-full hover:bg-yellow-600 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              <Instagram size={18} />
              Seguir no Instagram
            </a>
            <p className="text-brown-500 text-xs mt-3">
              @butecodobaianooficial
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}